module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    class: _vm.classes,
    attrs: {
      "src": _vm.image,
      "alt": _vm.alt
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fe5c353"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/modules/blurry-image.vue
// module id = 354
// module chunks = 0